import './CU.css';

function KeepKitCUPage() {
    return (
            <main className="contactus-page">

                <div className="contactus-container">

                    <h1>KeepKit Support</h1>

                    <p>Need help with KeepKit?</p>
                    <p>Contact: volt.uyc@gmail.com</p>
                    <p>I usually respond within 24–48 hours.</p>

                    <div className="contactus-divider"></div>

                    <div className="contactus-privacy">

                        <strong>Privacy</strong>

                        <br />
                        <br />

                        KeepKit stores all your data locally on your device.
                        We do not collect, track, or share any personal information.

                        <br />
                        <br />

                        Your data remains private and is only accessible on your
                        device unless you explicitly enable syncing features
                        (if available).

                    </div>
                </div>
            </main>
    );
}

export default KeepKitCUPage;